import Swiper from 'swiper'
import SwiperModule from '../lib/swiper-module'

class MshSocialProofSlider extends SwiperModule {
  constructor() {
    super()
    this.isInViewport = false
    this.setupViewportObserver()
  }

  setupViewportObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isInViewport = entry.isIntersecting
        if (!this.isInViewport) {
          this.pauseAllVideos()
        } else {
          // If we're back in viewport and have a swiper, play the active video
          if (this.swiper) {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex]
            const video = activeSlide?.querySelector('video')
            if (video) {
              video.play()
            }
          }
        }
      })
    }, options)
  }

  connectedCallback() {
    super.connectedCallback()
    this.observer.observe(this)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.observer.unobserve(this)
  }

  initSwiper() {
    const swiper = new Swiper(this.querySelector('.swiper'), {
      modules: this.swiperModules,
      slidesPerView: 1.5,
      scrollbar: {
        el: `#${this.id} .swiper-scrollbar`,
        hide: false,
      },
      loop: true,
      spaceBetween: '15px',
      navigation: {
        nextEl: `#${this.id} .custom-swiper-button-next`,
        prevEl: `#${this.id} .custom-swiper-button-prev`,
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },
      breakpoints: {
        1024: {
          spaceBetween: '20px',
          slidesPerView: 3.5,
        },
      },
    })

    window[`swiper_${this.id}`] = swiper
    this.swiper = swiper

    swiper.on('slideChange', this.slideChange.bind(this))
    this.setupAccessibility(swiper)

    const video = this.querySelector('video')
    if (video && this.isInViewport) {
      video.play()
    }
  }

  pauseAllVideos() {
    const videos = this.querySelectorAll('video')
    videos.forEach((video) => {
      video.pause()
    })
  }

  slideChange(e) {
    this.pauseAllVideos()
    const video = e.slides[e.activeIndex].querySelector('video')
    if (video && this.isInViewport) {
      video.play()
    }
  }
}

window.customElements.define('msh-social-proof-slider', MshSocialProofSlider)
